import axios from 'axios';
import { getCookie } from 'sutils';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { statusReport007 } from '@src/slide/infrastructure/module/dependent/report/real-time-report/real-time';
import { Reporter007, Reporter007ActionType } from '@src/slide/infrastructure/module/dependent/report/real-time-report/constant';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { DocReportType } from '@src/js/common/constants/report-run';
import config, { EnterPriseType } from '@src/js/service/enterprise/temp-config';
import { IReportManager } from '@src/slide/application/service/user-priviledge-service/report-manager/report-manager.interface';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { isClientDriveFile } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';    // 数据上报

class ReportManager implements IReportManager {
    // 只有第一次提交cs成功时上报
    private needReportCommitCSSuccess = true;

    public constructor() {
        SlideDataServices.SDKDataServices.EventManager.promise().then(({ revisionEvents }) => {
            revisionEvents.onCommitSucceed(() => {
                this.reportCommitCsSuccess();
            });
        });
    }

    public reportVisit(): void {
        // tdw访客上报
        const params = {
            opername: 'doc_core',
            module: 'visit',
            action: 'detail_page',
            // ...this.makeTdwMoreParams()
        };
        if (browser.isMobile) {
            statusReport007(Reporter007ActionType.SLIDE_PV_MOBILE, Reporter007.SUCCESS);
        } else {
            statusReport007(Reporter007ActionType.SLIDE_PV_PC, Reporter007.SUCCESS);
        }
        statusReport007(Reporter007ActionType.SLIDE_PV, Reporter007.SUCCESS);
        tdw(params);
        window.log.debug(params);
        this.reportDebugEnvId();
        if (config.supportEnterprise(EnterPriseType.ALL)) {
            this.reportOperateLog(DocReportType.DocOpenDoc);
        }
        if (browser.isMobile) {
            // 移动端本地编辑上报
            if (ENV.IS_MOBILE_LOCAL_EDIT) {
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.LOCAL_DOC,
                    action: TDWActionType.DOC_VIEW,
                    ver7: 'PPT',
                });
            }
            // 移动端云编文件上报
            if (isClientDriveFile()) {
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.DRIVE_DOC,
                    action: TDWActionType.DOC_VIEW,
                    ver7: 'PPT',
                });
            }
        }
    }

    private reportCommitCsSuccess(): void {
        if (this.needReportCommitCSSuccess) {
            const params = { // 上报
                opername: 'doc_core',
                module: 'edit',
                action: 'edit_text',
                // ...this.makeTdwMoreParams()
            };
            tdw(params);
            window.log.debug(params);
            this.needReportCommitCSSuccess = false;
        }
    }

    private reportOperateLog = (type: DocReportType) => {
        const docId = window.clientVars?.padId || '';
        const operTime = Math.floor(Date.now() / 1000);
        const url = `/doc/log_report?docid=${docId}&oper_time=${operTime}&type=${type}`;
        try {
            axios.get(url);
        } catch (e) {
            console.log(e.message);
        }
    };

    private reportDebugEnvId() {
        const envId = getCookie('env_id');
        if (envId && envId !== 'uat' && envId.indexOf('sit') !== 0) {
            const params = {
                opername: 'online_envid',
                module: 'visit',
                action: 'detail_page',
                errorMsg: {
                    envId,
                    platform: browser.isMobile ? 'mobile' : 'pc',
                },
            };
            statusReport007(Reporter007ActionType.SLIDE_PV_ENVID, Reporter007.SUCCESS);
            tdw(params);
            window.log.debug(params);
        }
    }
}

export default ReportManager;
